import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ReactComponent as LocationIcon } from "../../../design-system/design_system/assets/icons/system/location/filled.svg";
import { ReactComponent as SearchIcon } from "../../../design-system/design_system/assets/icons/system/search.svg";
import { ReactComponent as SearchHistoryIcon } from "../../../design-system/design_system/assets/icons/system/history.svg";
import { ReactComponent as WarningIcon } from "../../../design-system/design_system/assets/icons/components/notifications/warning.svg";
import{ ReactComponent as NotificatinWarningIcon } from "../../../design-system/design_system/assets/icons/components/notifications/warning.svg"
import RCIDatePickerContainer from "../RCIDatePickerContainer";
import ReactHtmlParser from 'html-react-parser';
import Overlay from "../overlay";
import { ScreenOriantation, ScreenType } from "../../../utils/detectScreen";
//import searchData from "./searchData.json";
import { formateDate, SearchApiDateFormate, searchDateFormatter, getCalDurationEnd } from "../../../utils/dateFormate";
import { ReactComponent as CloseIcon } from "../../../design-system/design_system/assets/icons/components/notifications/close.svg";
import { getDataFromAPI, retryServiceCall } from "../../../service";
//import{ClearDateCalenderSelection} from "../../actions";
import store from '../../../store/store';
import { useMediaQuery } from 'react-responsive';
import axios from 'axios';
let searchKeyWord = "";
let latestCheckOutDateClicked = 0;
let lastSelctedCheckoutDate = ""
const SearchTray = ({ handleFauxSearchfunc,
    displaySearchTrayFlag,
    typeAheadSearchLabelTxt, searchData, $deviceWidth }) => {
    let orientationType = ScreenOriantation();
    //const dispatch = useDispatch();
    let SearchstartDate = new Date();
    SearchstartDate = SearchstartDate.setDate(SearchstartDate.getDate() + 2);
    const searchTrayWrapper = useRef();
    const [recentSearchData, setrecentSearchData] = useState(null)
    const [showRegion, setshowRegion] = useState(false);
    const [showSubRegion, setshowSubRegion] = useState(false);
    const [displayCheckinCalender, setDisplayCheckinCalender] = useState(false);
    const [displayCheckOutCalender, setDisplayCheckOutCalender] = useState(false);
    const [regionName, setRegionName] = useState("");
    const [displayCheckInDate, setDisplayCheckInDate] = useState(false);
    const [displayCheckOutDate, setDisplayCheckOutDate] = useState(false);
    const [hideSearch, setHideSearch] = useState(false);
    const [displayCloseIcon, setDisplayCloseIcon] = useState(true);
    const [sendCheckinDate, setSendCheckinDate] = useState(new Date(SearchstartDate));
    const [sendCheckOutDate, setSendCheckOutDate] = useState("");
    const [searchResultData, setSearchResultData] = useState(null);
    const [searchSelected, setsearchSelected] = useState(false);
    const [searchClearBtn, setSearchClearBtn] = useState(false);
    const [checkInClearBtn, setCheckInClearBtn] = useState(false);
    const [mobileCalenderCheckInClearBtn, setMobileCalenderCheckInClearBtn] = useState(false);
    const [mobileCalenderCheckOutClearBtn, setMobileCalenderCheckOutClearBtn] = useState(false);
    const [latestCheckInClearBtn, setLatestCheckInClearBtn] = useState(false);
    const [displayErrorMsg, setDisplayErrorMsg] = useState(false);
    const [availibilityContainer, setAvailibilityContainer] = useState(false);
    const [availibilityCalenderRes, setAvailibilityCalenderRes] = useState(null);
    const [availibilityCalenderBtn, setAvailibilityCalenderBtn] = useState(null);
    const [availibilityCalenderMsg, setAvailibilityCalenderMsg] = useState(null);
    /* const [checkinCalStartDate , setcheckinCalStartDate] = useState(); */
    let checkinCalStartDate = new Date(SearchstartDate);
    const dateCalenderRef = useRef();
    //const [retryServiceCall, setRetryServiceCall] = useState(false);
    var date = new Date();
    var year = date.getFullYear();
    var month = date.getMonth();
    var day = date.getDate();
    var deafultCheckInDate = searchDateFormatter(new Date(year,month,day + 2));
    const custlocale = useSelector(state => state.CommonReducer.locale);
    const [searchObj, setSearchObj] = useState({
        searchText: "",
        checkInFromDate: "",
        checkInToDate: "",
        minCheckinDate: "",
        maxCheckinDate: "",
        searchTerm: "",
        searchTextTyped: "",
        resortId: "",
        latitude: "",
        longitude: "",
        id: "",
        typeName: "",
        typeAheadSearchBy: "",
        displayAddLabel: "",
        rebrandSearchKey: "",
        expRadius: "",
        isEligible: false,
        heroFlag: false,
        noVseRes: false,
        fromInterstitial: false,
        autoCorrectFlag: false,
        typeAheadFlag: true,
        sourceType: "TypeAhead",
        allDateRange: "",
        newSearch: true,
        wowRebrandFlag: true,
        regionId: "",
        regionName: "",
        productType:custlocale === "en_US" ? "Exchange" :"Exchange-LastCall-ExtraVacation"
    });
    const { REACT_APP_IMAGEURL, REACT_APP_SERVICE_URL } = window.weeksWebCloudConfig;
   
    const accessToken = useSelector(state => state.CommonReducer.accessToken);
    const customerId = useSelector(state => state.CommonReducer.customerId);
    const searchCustlocale = useSelector(state => state.CommonReducer.customerProfile.typeaheadLanguageCode);
    let custlocaleFormated = custlocale.split('_').join('-');
    let customerLanguage = custlocale.split('_')[0]
    const recentSearchUrl = `${REACT_APP_SERVICE_URL}/customer/${customerId}/preferences/favorites-recent-search`;
    const searchUrl = `${REACT_APP_SERVICE_URL}/searchTypeahead/inventory/${searchCustlocale}`;
    const availibilityCalenderUrl = `${REACT_APP_SERVICE_URL}/rcio/${customerId}/ownerships/getTACalendarAvailability`;
    //console.log(memberShipType);
    let retryCount = 1;
    const inputRef = useRef();
    const isDesktopOrIpadLandscape = useMediaQuery({
        query: '(min-width: 1024px)'
      })
   
    useEffect(() => {
    }, [regionName, searchObj, sendCheckOutDate])
    /* const availibilityCalenderData = async () =>{
        let availibilityCalenderRes = await getDataFromAPI(availibilityCalenderUrl,'GET', customerId, '', '', '') 
        } */
        //@ function for showing deposit message in date calender section
       if(displayCheckinCalender || displayCheckOutCalender){
        setTimeout(() => {
            let checkInCalenderNextBtnElement = document.getElementById('next-month');
            let checkInCalenderPrevBtnElement = document.getElementById('prev-month');
            let DepMsgwithBtn, DepMsg, msgBtn;
            checkInCalenderNextBtnElement.addEventListener("click", function() {
                if(availibilityCalenderRes === null){   
                 getDataFromAPI(availibilityCalenderUrl,'GET', customerId, '', '', '').then(res=>{
                    if(res.status === 200){
                        setAvailibilityCalenderRes(res.data);
                        DepMsgwithBtn = res.data.dropdownTxtTrvlWin;
                        DepMsg = DepMsgwithBtn.replace(/<b>/g, "");
                        msgBtn = DepMsg.match(/<span.*?>.*?<\/span.*?>/s);
                        DepMsg = msgBtn.input;
                        DepMsg = DepMsg.split("<span class=depositClick>");
                        setAvailibilityCalenderBtn(msgBtn[0]);
                        setAvailibilityCalenderMsg(DepMsg[0]);
                    } 
                    else{
                        let msgres = {
                            travelWindowDivider:"May 2022",
                            dropdownTxtTrvlWin:"<b>The great vacation you’re looking for may be beyond your deposit’s travel window!</b><br>Consider Extending, Combining, or Depositing additional time.  <span class=depositClick> Manage My Deposits »</span>"
                        }
                        setAvailibilityCalenderRes(msgres);
                        DepMsgwithBtn = msgres.dropdownTxtTrvlWin;
                        DepMsg = DepMsgwithBtn.replace(/<b>/g, "");
                        msgBtn = DepMsg.match(/<span.*?>.*?<\/span.*?>/s);
                        DepMsg = msgBtn.input;
                        DepMsg = DepMsg.split("<span class=depositClick>");
                        setAvailibilityCalenderBtn(msgBtn[0]);
                        setAvailibilityCalenderMsg(DepMsg[0])
                    }
                 })
            }
                let displayingMonth = "";
                let dayPickerContentElem =  document.getElementsByClassName("DayPicker-Caption");
                let DayPickerCaptionElemCount = dayPickerContentElem.length;
                if(isDesktopOrIpadLandscape){
                    displayingMonth = DayPickerCaptionElemCount >1 ? dayPickerContentElem[1].innerText : dayPickerContentElem[0].innerText;
                    if(availibilityCalenderRes !== null && availibilityCalenderRes.travelWindowDivider === displayingMonth){
                        setAvailibilityContainer(true);
                     }
                }
                else{
                    setTimeout(() => {
                        displayingMonth = DayPickerCaptionElemCount >1 ? dayPickerContentElem[1].innerText : dayPickerContentElem[0].innerText;
                        if(availibilityCalenderRes !== null && availibilityCalenderRes.travelWindowDivider === displayingMonth){
                            setAvailibilityContainer(true);
                         }
                    },200)
                    
                }
              });
            
        }, 100)
       }

       //@ function for selcting earliest checkin date from date calender 

    const earliestCheckInDayEvent = function (fromDate, toDate, daysModifiers) {
        let payloadParam = {
            clearClicked: false,
            selectedCheckInDate: sendCheckinDate
        }
        let checkOutPayloadParam = {
            clearClicked: true,
            selectedCheckInDate: undefined
        }
        if(isDesktopOrIpadLandscape){
            setCheckInClearBtn(true);
        }
        else{
            setCheckInClearBtn(true);
            setMobileCalenderCheckInClearBtn(true);
        } 
        setSendCheckinDate(fromDate);
        //setSendCheckOutDate(fromDate);
        setDisplayCheckInDate(formateDate(custlocale, fromDate));
        setDisplayCheckinCalender(false);
        if ($deviceWidth > 1024) setDisplayCheckOutCalender(true);
        else setDisplayCloseIcon(true);
        store.dispatch({ type: 'CLEAR_CHECKIN_DATE', payload: payloadParam });
        if(sendCheckOutDate ===""){
            //setSearchObj({ ...searchObj, checkInFromDate: searchDateFormatter(fromDate), checkInToDate: searchDateFormatter(getCalDurationEnd())});
            setSearchObj({ ...searchObj, checkInFromDate: searchDateFormatter(fromDate)});
            store.dispatch({ type: 'CLEAR_CHECKOUT_DATE', payload: checkOutPayloadParam });
        }
        else{
            setSearchObj({ ...searchObj, checkInFromDate: searchDateFormatter(fromDate)});
        }
        //debugger;
        if(fromDate > sendCheckOutDate){
            setDisplayCheckOutDate(false);
            setLatestCheckInClearBtn(false);
            setMobileCalenderCheckOutClearBtn(false);
            setSearchObj({ ...searchObj, checkInFromDate: searchDateFormatter(fromDate), checkInToDate:""});
        };
    }

    //@ function for selcting latest checkin date from date calender
    const latestCheckInDayEvent = function (fromDate, toDate) {
       
        //debugger;
        let payloadParam = {
            clearClicked: false,
            selectedCheckInDate: sendCheckinDate
        }
        setSendCheckOutDate(fromDate);
       
        if(toDate === undefined){
            setDisplayCheckOutDate(formateDate(custlocale, fromDate))
            setSearchObj({ ...searchObj, checkInToDate: searchDateFormatter(fromDate)});
            lastSelctedCheckoutDate = fromDate;
        }
        else{
            if( fromDate !== sendCheckOutDate){
                //debugger;
                if(!latestCheckInClearBtn){
                    if(latestCheckOutDateClicked > 0){
                        if(toDate !== undefined && fromDate !== undefined){
                            if(toDate !== lastSelctedCheckoutDate){
                                setDisplayCheckOutDate(formateDate(custlocale, toDate))
                                setSearchObj({ ...searchObj, checkInToDate: searchDateFormatter(toDate)});
                                lastSelctedCheckoutDate = toDate;
                            }
                            else{
                                setDisplayCheckOutDate(formateDate(custlocale, fromDate))
                                setSearchObj({ ...searchObj, checkInToDate: searchDateFormatter(fromDate)});
                                lastSelctedCheckoutDate = fromDate;
                            }
                        }
                        else{
                            setDisplayCheckOutDate(formateDate(custlocale, toDate))
                            setSearchObj({ ...searchObj, checkInToDate: searchDateFormatter(toDate)})
                        } 
                    } 
                    /* if(toDate!== undefined)setDisplayCheckOutDate(formateDate(custlocale, toDate)) */
                    else {
                        setDisplayCheckOutDate(formateDate(custlocale, fromDate));
                        setSearchObj({ ...searchObj, checkInToDate: searchDateFormatter(fromDate)})
                    }
                }
               else{
                setDisplayCheckOutDate(formateDate(custlocale, fromDate))
                setSearchObj({ ...searchObj, checkInToDate: searchDateFormatter(fromDate)})
               }
               
            } 
            else{
                setDisplayCheckOutDate(formateDate(custlocale, toDate))
                setSearchObj({ ...searchObj, checkInToDate: searchDateFormatter(toDate)})
            } 
        }
        if(isDesktopOrIpadLandscape){
            setLatestCheckInClearBtn(true);
        }
        else{
            setLatestCheckInClearBtn(true);
            setMobileCalenderCheckOutClearBtn(true);
        }
        
        if(!isDesktopOrIpadLandscape) setDisplayCheckOutCalender(false);
        if ($deviceWidth < 1024) setDisplayCloseIcon(true);
        /* if(searchObj.checkInFromDate === ""){
            setSearchObj({ ...searchObj, 
                checkInFromDate: deafultCheckInDate, 
                checkInToDate: searchDateFormatter(fromDate)  
            })
            
        } */
        store.dispatch({ type: 'CLEAR_CHECKOUT_DATE', payload: payloadParam });
        latestCheckOutDateClicked++;
        
        }

    const _onApplyBtnClick = () => {
        setDisplayCheckOutCalender(false);
        setDisplayCheckinCalender(false);
    }
    //@ function for hiding checkin datepicker

    const hideCheckInDatePicker = function () {
        setSendCheckinDate(new Date(SearchstartDate));
        setDisplayCheckInDate(false);
        setAvailibilityContainer(false);
    }

    //@ function for hiding checkout datepicker
    const hideCheckOutDatePicker = function () {
        setSendCheckOutDate(sendCheckinDate);
        setDisplayCheckOutDate(false);
        setAvailibilityContainer(false);
    }

    //@ function for search result
    const submitSearch = () => {
       //debugger;     
        if(searchObj.searchText === "" && searchObj.checkInFromDate === "" && searchObj.checkInToDate === "" ){
            setshowRegion(true);
            setDisplayErrorMsg(true);
            displayRecentSearch();
            if(!isDesktopOrIpadLandscape){
                setTimeout(() => {
                    document.getElementById("mobile-search-input").focus();
                }, 1000);
            }
           
        }
        else if(searchObj.searchText === "" && searchKeyWord !== ""){
            setshowRegion(true);
            setDisplayErrorMsg(true);
            displayRecentSearch();
            if(!isDesktopOrIpadLandscape){
                setTimeout(() => {
                    document.getElementById("mobile-search-input").focus();
                }, 1000);
            }
        }
        else{
            setshowRegion(false);
            setDisplayCheckinCalender(false);
            setDisplayCheckOutCalender(false);
            setAvailibilityContainer(false);
            handleFauxSearchfunc();
            setHideSearch(true);
            let sendCheckInFromDateToSearch = searchObj.checkInFromDate;
            let sendCheckInToDateToSearch = searchObj.checkInToDate;
            if (searchObj.checkInFromDate==="" && searchObj.checkInToDate===""){
                setshowRegion(true);
                setDisplayErrorMsg(true);
                displayRecentSearch();
            }
            if(searchObj.typeName === "Resort" && searchObj.checkInFromDate===""){
                sendCheckInFromDateToSearch = deafultCheckInDate
            }
            else if(searchObj.checkInFromDate==="" && searchObj.checkInToDate!==""){
                sendCheckInFromDateToSearch = deafultCheckInDate
            }
            if(searchObj.typeName === "Resort" && searchObj.checkInToDate===""){
                sendCheckInToDateToSearch = searchDateFormatter(getCalDurationEnd());
                //setSearchObj({...searchObj, checkInToDate:searchDateFormatter(getCalDurationEnd())})
            }
            else if(searchObj.checkInToDate==="" && searchObj.checkInFromDate!==""){
                sendCheckInToDateToSearch = searchDateFormatter(getCalDurationEnd());
            }
            //setRegionName("");
            //clearAllDates();
            //clearSearchKey();
            //setshowRegion(false)
            //debugger;
            let searchResultUrl = `/weeks-search/${searchObj.productType}/list-view?searchText=${encodeURIComponent(searchObj.searchText)}&month=&checkInFromDate=${sendCheckInFromDateToSearch}&checkInToDate=${sendCheckInToDateToSearch}&minCheckinDate=${sendCheckInFromDateToSearch}&maxCheckinDate=${sendCheckInToDateToSearch}&searchTerm=${encodeURIComponent(searchObj.searchText)}&searchTextTyped=${encodeURIComponent(searchKeyWord)}&resortId=${searchObj.resortId}&latitude=${searchObj.latitude}&longitude=${searchObj.longitude}&id=${searchObj.id}&typeName=${searchObj.typeName}&typeAheadSearchBy=${searchObj.typeAheadSearchBy}&displayAddLabel=${searchObj.displayAddLabel}&rebrandSearchKey=&expRadius=false&isEligible=false&heroFlag=false&noVseRes=false&fromInterstitial=false&autoCorrectFlag=false&typeAheadFlag=true&sourceType=TypeAhead&allDateRange=&newSearch=true&wowRebrandFlag=true`;
            document.getElementById("quick-search-form").action = searchResultUrl;
            //process.env.NODE_ENV !== "development" &&
            document.getElementById("quick-search-form").submit();
        }
       
    }

    //@ function for clearing all dates from state and and display box
    const clearAllDates = () => {
        //debugger;

        // const clearDate = {cheknIndate:clearCheckinDate,cheknOutdate : clearCheckOutDate }
        setDisplayCheckInDate(false);
        setDisplayCheckOutDate(false);
        setCheckInClearBtn(false);
        setLatestCheckInClearBtn(false);
        setSendCheckinDate(new Date(SearchstartDate))
        isDesktopOrIpadLandscape ? setDisplayCheckinCalender(true):setDisplayCheckinCalender(false);
        setDisplayCheckOutCalender(false);
        setMobileCalenderCheckInClearBtn(false);
        setMobileCalenderCheckOutClearBtn(false);
        //return clearDate;
        setSearchObj({ ...searchObj, checkInFromDate:"", checkInToDate:"" })
    }



    //@ function for closing the search location options
    const closeSearOptions = (event) => {
        if (showRegion || showSubRegion || displayCheckinCalender || displayCheckOutCalender) {
            setshowRegion(false);
            setshowSubRegion(false);
            setDisplayCheckinCalender(false);
            setDisplayCheckOutCalender(false);
            setAvailibilityContainer(false);
            setAvailibilityContainer(false);
            document.body.classList.remove("no-body-scroll");
        }
    }
    //@ function for closing the search tray
    var searchTrayClose = function (event) {
        //debugger;
        //handleFauxSearchfunc();
        if (showRegion || showSubRegion || displayCheckinCalender || displayCheckOutCalender) closeSearOptions();
        else handleFauxSearchfunc();
    }


    //@ function for Selecting a location option from typeahead option list
    const selectSearchOptions = (event, optionData) => {
        if(event.keyCode === 13 || event.type === "click"){
        const retryOptoionData = optionData
        /* const optionResortString = optionData.label
        let formattedResortName = optionResortString.replace(/\s/g, "+"); */
        setRegionName(optionData.label);
        setshowRegion(false);
        setsearchSelected(true);
        //debugger;
        if (optionData.typeName === "Geocode") {
                getDataFromAPI(
                    `${REACT_APP_SERVICE_URL}/searchTypeahead/googleDetailServlet?placeid=${optionData.value}`,
                    'GET', 
                    customerId, 
                    '', 
                    '', 
                    '').then(res => {
                        if (res.status === 200) {
                            setSearchObj({
                                ...searchObj,
                                searchText: optionData.label,
                                searchTerm: optionData.label,
                                latitude: res.data.lat,
                                longitude: res.data.lng,
                                typeName: optionData.typeName,
                                typeAheadSearchBy: optionData.addlabel,
                                displayAddLabel: optionData.displayAddLabel
                        })
                    
                }
                else {
                    if (retryCount <= 2) retryServiceCall(customerId, custlocale).then(retryRes => {
                        retryCount++;
                        //debugger;
                        retryRes.valid === "true" && selectSearchOptions(event, retryOptoionData);
                    })
                }
            })
            
            
        }
        else if (optionData.typeName === "Dimension") {
            setSearchObj({
                ...searchObj,
                searchText: optionData.label,
                searchTerm: optionData.label,
                typeName: optionData.typeName,
                id: optionData.value,
                resortId: "",
                typeAheadSearchBy: optionData.addlabel,
                displayAddLabel: optionData.displayAddLabel
            })
        }
        else {
            if (optionData.typeName === "Resort") {
                setSearchObj({
                    ...searchObj,
                    searchText: optionData.label,
                    searchTerm: optionData.label,
                    typeName: optionData.typeName ,
                    typeAheadSearchBy: optionData.addlabel,
                    displayAddLabel: optionData.displayAddLabel,
                    resortId: optionData.value,
                    id: "",
                    productType:"Exchange-LastCall-ExtraVacation"
                })
            }
            else {
                setSearchObj({
                    ...searchObj,
                    searchText: optionData.label,
                    searchTerm: optionData.label,
                    typeName: optionData.typeName,
                    typeAheadSearchBy: optionData.addlabel,
                    displayAddLabel: optionData.displayAddLabel,
                    id: "",
                    resortId: optionData.value,
                    
                })
            }
        }
        if($deviceWidth>1024)setDisplayCheckinCalender(true);
        else backMainSearch();
        setSearchClearBtn(true);
        setDisplayErrorMsg(false);
        //debugger;

        }
        else return false;
        
    }

    //@ function for Selecting a location option from typeahead reecent search option list
    const selectRecentSearchOptions = (event, optionData) => {
        if(event.keyCode === 13 || event.type === "click"){
            //const retryOptoionData = optionData
            /* const optionResortString = optionData.label
            let formattedResortName = optionResortString.replace(/\s/g, "+") */
            setRegionName(optionData.label);
            setshowRegion(false);
            setsearchSelected(true);
            //debugger;
            if (optionData.searchType === "Geocode") {
                setSearchObj({
                    ...searchObj,
                    searchText: optionData.label,
                    searchTerm: optionData.label,
                    latitude: optionData.latitude,
                    longitude: optionData.longitude,
                    typeName: optionData.searchType,
                    typeAheadSearchBy: optionData.addlabel,
                    displayAddLabel: optionData.displayAddLabel
                })   
            }
            else if (optionData.searchType === "Dimension") {
                setSearchObj({
                    ...searchObj,
                    searchText: optionData.label,
                    searchTerm: optionData.label,
                    typeName: optionData.searchType,
                    id: optionData.xmlId,
                    resortId: "",
                    typeAheadSearchBy: optionData.addlabel,
                    displayAddLabel: optionData.displayAddLabel
                })
            }
            else if (optionData.searchType === "Resort") {
                //debugger;
                setSearchObj({
                    ...searchObj,
                    searchText: optionData.label,
                    searchTerm: optionData.label,
                    typeName: optionData.searchType,
                    id: "",
                    resortId: optionData.resortCode,
                    typeAheadSearchBy: optionData.addlabel,
                    displayAddLabel: optionData.displayAddLabel,
                    productType:"Exchange-LastCall-ExtraVacation"
                })
            }
            else {
                if (optionData.searchType === "City") {
                    setSearchObj({
                        ...searchObj,
                        searchText: optionData.label,
                        searchTerm: optionData.label,
                        typeName: optionData.searchType,
                        typeAheadSearchBy: optionData.addlabel,
                        displayAddLabel: optionData.displayAddLabel,
                        id: optionData.xmlId,
                        resortId: ""
                    })
                }
                else {
                    setSearchObj({
                        ...searchObj,
                        searchText: optionData.label,
                        searchTerm: optionData.label,
                        typeName: optionData.searchType,
                        typeAheadSearchBy: optionData.addlabel,
                        displayAddLabel: optionData.displayAddLabel,
                        id: optionData.xmlId,
                        resortId:""
                    })
                }
            }
            if($deviceWidth>1024)setDisplayCheckinCalender(true);
            else backMainSearch();
            //availibilityCalenderData()
            setSearchClearBtn(true)
            setDisplayErrorMsg(false);
            //debugger;
        }
        else return false;
        
    }
//@ function for displaying reecent search option list
 const displayRecentSearch = () => {
        getDataFromAPI(recentSearchUrl, 'GET', customerId, '', accessToken, customerLanguage, custlocale).then(res => {
            if (res.status === 200) {
                if (res.data) {  
                    setrecentSearchData(res.data.recentSearch);
                }

            }
        });
        if (!showRegion) {
            setshowRegion(true);
            //setshowSubRegion(false);
            setDisplayCheckinCalender(false);
            setDisplayCheckOutCalender(false);
            setAvailibilityContainer(false);
            document.body.classList.add("no-body-scroll");
        }
        else {
            if(searchObj.searchText !== "")setshowRegion(false);
            
        }
    }

//@ function for displaying reecent search option list in mobile
    const mobileDisplayRecentSearch = () => {
        getDataFromAPI(recentSearchUrl, 'GET', customerId, '', accessToken, customerLanguage, custlocale).then(res => {
            if (res.status === 200) {
                if (res.data) {  
                    setrecentSearchData(res.data.recentSearch);
                }

            }
        });
        if (!showRegion) {
            setshowRegion(true);
            //setshowSubRegion(false);
            setDisplayCheckinCalender(false);
            setDisplayCheckOutCalender(false);
            setAvailibilityContainer(false);
            //setDisplayCloseIcon(false);
            //debugger;
            document.body.classList.add("no-body-scroll");
        }
        else {
            if(searchObj.searchText !== "")setshowRegion(true);
            
        }
    }


//@ function for showing checkin calender in search tray on click the input field
    const showCheckInCalender = (e) => {
        if (!displayCheckinCalender) {
            document.body.classList.add("no-body-scroll");
            setDisplayCheckinCalender(true);
            setDisplayCheckOutCalender(false);
            setshowRegion(false);
            setshowSubRegion(false);
        }
        store.dispatch({type:"CHECKOUT_CONTAINER_CLICK", payload:false});
        if(searchObj.checkInFromDate === deafultCheckInDate){
            store.dispatch({type:"CHECKIN_CONTAINER_CLICK", payload:true})
        }
        else store.dispatch({type:"CHECKIN_CONTAINER_CLICK", payload:false});
        
    }
//@ function for showing checkout calender in search tray on click the input field

    const showCheckOutCalender = (e) => {
        e.stopPropagation();
        if (!displayCheckOutCalender) {
            document.body.classList.add("no-body-scroll");
            //setSendCheckOutDate(sendCheckinDate);
            setSendCheckinDate(sendCheckinDate);
            setDisplayCheckOutCalender(true);
            setDisplayCheckinCalender(false);
            setshowRegion(false);
            store.dispatch({type:"CHECKOUT_CONTAINER_CLICK", payload:true})
        }
    }
//@ function for mobile back to main search tray
    const backMainSearch = (e) => {
        //e.stopPropagation();
        setshowRegion(false);
        setshowSubRegion(false);
        setDisplayCheckinCalender(false);
        setDisplayCheckOutCalender(false);
        setAvailibilityContainer(false);
        //setDisplayCloseIcon(true);
    }
    //@ tooltip function for calender label text
    const tooltipdisplay = (e) => {
        const tooltipEle = e.currentTarget.nextSibling.classList;
        //const tooltipContent = e.currentTarget.textContent;
        const tooltipContentLength = e.currentTarget.offsetWidth;
        if (tooltipContentLength > 175) {
            if (e.type === "mouseover") tooltipEle.add("show");
            if (e.type === "mouseout") tooltipEle.remove("show");
        }
    }
     //@ function for closing search option dropdown
    const closeSearchOption = (event) => {
        !searchTrayWrapper.current.contains(event.target) && closeSearOptions();
    }
     
    //@ function for getting the location option dropdown list
    const getSearchResult = async (e) => {
        setSearchObj({...searchObj, searchText:""});
        setDisplayErrorMsg(false);
        setRegionName(e.target.value)
        searchKeyWord = e.target.value;
        let searResult;
        if (searchKeyWord.length > 2) {
            setSearchClearBtn(true);
            searResult = await getDataFromAPI(`${searchUrl}?Ntt=${encodeURIComponent(searchKeyWord)}*`, 'GET', customerId);
            searResult.data !== undefined ? setSearchResultData(searResult.data.searchGroup):setSearchResultData(null);
            setshowRegion(true);
            //debugger;
            //console.log(searchResultData);
        }
        else {
            setSearchResultData(null);
            setSearchClearBtn(false);
        }
    }

   
//@ function for clearing the location typed or selected in location input field
    const clearSearchKey = () => {
        searchKeyWord = "";
        setRegionName("");
        setSearchObj({...searchObj, 
            searchText : "", 
            typeName:"", 
            typeAheadSearchBy:"", 
            displayAddLabel:"", 
            id:"", 
            resortId:"",
            latitude:"",
            longitude:""
        });
        setSearchClearBtn(false);
        isDesktopOrIpadLandscape && displayRecentSearch();
        setSearchResultData(null);
        document.getElementById("search-input").focus();
        
    }
//@ function for clearing the location typed or selected in location input field for mobile
    const clearSelectedLocationMobile = () => {
        setRegionName("");
        setSearchObj({...searchObj, searchText : ""});
        setSearchClearBtn(false);
        setSearchResultData(null);
        setTimeout(() => {
            document.getElementById("mobile-search-input").focus();
        }, 500);
    }
   

    /* const clearNonDesktopSearch = () => {
        //debugger;
        setRegionName("");
        setSearchObj({...searchObj, searchText : ""});
        setSearchClearBtn(false);
        setSearchResultData(null);
        //document.getElementById("search-input").focus();
    }  */

    //@ function for clearing the earliest Chceckin Date from input field and state

    const ClearEarliestCkeckInDate = () => {
        //debugger;
        let payloadParam = {
            clearClicked: true,
            selectedCheckInDate: sendCheckinDate
        }
        store.dispatch({ type: 'CLEAR_CHECKIN_DATE', payload: payloadParam });
        setSendCheckinDate(new Date(SearchstartDate));
        /* setSearchObj({...searchObj, checkInFromDate:deafultCheckInDate}) */
        setSearchObj({...searchObj, checkInFromDate:""})
        setCheckInClearBtn(false);
        setMobileCalenderCheckInClearBtn(false);
        setDisplayCheckInDate(false);
        setDisplayCheckOutCalender(false);
        if(isDesktopOrIpadLandscape){
            setDisplayCheckinCalender(true);
            setDisplayCheckOutCalender(false);
        }
        else{
            setDisplayCheckinCalender(false)
        }
        // earliestCheckInDayEvent(sendCheckinDate,sendCheckOutDate);
    }
 //@ function for clearing the Mobile earliest Chceckin Date from input field and state
    const ClearMobileEarliestCkeckInDate = () => {
        //debugger;
        let payloadParam = {
            clearClicked: true,
            selectedCheckInDate: sendCheckinDate
        }
        store.dispatch({ type: 'CLEAR_CHECKIN_DATE', payload: payloadParam });
        setSendCheckinDate(new Date(SearchstartDate));
        setSearchObj({...searchObj, checkInFromDate:""});
        setMobileCalenderCheckInClearBtn(false);
        setDisplayCheckInDate(false);
        setCheckInClearBtn(false);
    }
//@ function for clearing the latest Chceckin Date from input field and state
    const ClearLatestCkeckInDate = () => {
        let payloadParam = {
            clearClicked: true,
            selectedCheckInDate: undefined
        }
        store.dispatch({ type: 'CLEAR_CHECKOUT_DATE', payload: payloadParam });
        setSendCheckOutDate("");
        setLatestCheckInClearBtn(false);
        setMobileCalenderCheckOutClearBtn(false);
        setDisplayCheckOutDate(false);
        /* setSearchObj({...searchObj, checkInToDate:searchDateFormatter(getCalDurationEnd())}) */
        setSearchObj({...searchObj, checkInToDate:""});
        if(isDesktopOrIpadLandscape){
            setDisplayCheckOutCalender(true);
            setDisplayCheckinCalender(false);
        }else{
            setDisplayCheckOutCalender(false);
        }

    }
//@ function for clearing the mobile latest Chceckin Date from input field and state
    const ClearMobileLatestCkeckInDate = () => {
        let payloadParam = {
            clearClicked: true,
            selectedCheckInDate: undefined
        }
        store.dispatch({ type: 'CLEAR_CHECKOUT_DATE', payload: payloadParam });
        setSendCheckOutDate("");
        setSearchObj({...searchObj, checkInToDate:""});
        setMobileCalenderCheckOutClearBtn(false);
        setLatestCheckInClearBtn(false);
        setDisplayCheckOutDate(false);

    }
//@ earliest checkin calendar component 
    const CheckInDateCal = <RCIDatePickerContainer
        closeBtn={false}
        calenderHeading={false}
        showdatePickerlables={false}
        localCal={custlocaleFormated}
        id="checkIndatePickerContainer"
        calmonths={2}
        applyBtnfn={_onApplyBtnClick}
        calCheckinDayBtnFn={earliestCheckInDayEvent}
        toggleDatePickerhide={hideCheckInDatePicker}
        StartDate={checkinCalStartDate}
        toMonth={getCalDurationEnd()}
        clearDates={clearAllDates}
        highlightBothSelectedDays={false}
        isIpadLandscape = {isDesktopOrIpadLandscape}
        defaultDate = {deafultCheckInDate}
    />



    const calApplyBtnClickevent = () => {
    }

//@ latest checkin calendar component 
    const CheckOutDateCal = <RCIDatePickerContainer
        closeBtn={false}
        calenderHeading={false}
        showdatePickerlables={false}
        localCal={custlocaleFormated}
        id="checkOutdatePickerContainer"
        calmonths={2}
        applyBtnfn={_onApplyBtnClick}
        toggleDatePickerhide={hideCheckOutDatePicker}
        StartDate={sendCheckinDate}
        toMonth={getCalDurationEnd()}
        calCheckinDayBtnFn={latestCheckInDayEvent}
        clearDates={clearAllDates}
        highlightBothSelectedDays={true}
        showSelctedCheckinDays={sendCheckinDate}
        isIpadLandscape = {isDesktopOrIpadLandscape}
        defaultDate = {deafultCheckInDate}
    />

//@ function for clearing the mobile search input

    const mobileSearchTraySlide = () => {
        setDisplayErrorMsg(false);
        getDataFromAPI(recentSearchUrl, 'GET', customerId, '', '', customerLanguage, custlocale).then(res => {
            if (res.status === 200) {
                if (res.data) {
                    //console.log("resort Data",res.data);
                    setrecentSearchData(res.data.recentSearch);
                }

            }
            if (!showRegion) {
                setshowRegion(true);
                //setshowSubRegion(false);
                setDisplayCheckinCalender(false);
                setDisplayCheckOutCalender(false);
                document.body.classList.add("no-body-scroll");
                //document.getElementById("mobile-search-input").focus();
               
            }
            
        });
        setTimeout(() => {
            document.getElementById("mobile-search-input").focus();
        }, 1000);

    }

    return (
        <>
       
            <div
                className={displaySearchTrayFlag ? "search-tray p-5 bg-breeze slide-tray" : "search-tray p-5 bg-breeze d-lg-none"}
                onClick={closeSearchOption}
                aria-describedby="location-search-section"
                role='dialog'
            >
                <h1 className="display-3 pt-4 d-none d-lg-block">{typeAheadSearchLabelTxt.MTHeadingText}</h1>
                <button className="close-search d-lg-none" onClick={handleFauxSearchfunc}>
                    <CloseIcon width="24px" height="24px" />
                </button>
                <div ref={searchTrayWrapper} className={`bg-white align-content-start h-100 px-3 mt-5 row overflow-scroll 
                ${showRegion || displayCheckinCalender || displayCheckOutCalender ? "search-tray-positioning" : ""}`}>
                    <div className="col-12 border-bottom d-lg-none py-3 text-center ">
                        <a className="points-x-small float-left bold black-link-color" href="#!" onClick={handleFauxSearchfunc}>
                            <img src={`${REACT_APP_IMAGEURL}/static/images/rebrand-ds/Arrow-left.png`} width="24px" height="24px" />
                           
                        </a>
                        <span>{typeAheadSearchLabelTxt.HeadingText}</span>
                    </div>
                    <div
                        className={`search-row-border py-3 py-lg-3 py-lg-0 p-lg-0 ${(showRegion && !showSubRegion) ? "col-lg-7"
                            : "col-lg-4"}`} >
                        <div className="button-wrapper-container mx-0 d-none d-md-block mt-2">
                            <div className='col-12'>
                                <label className="bold mb-0 font-weight-bolder">{typeAheadSearchLabelTxt.LocationLabelTxt}</label>
                            </div>

                            <div className='d-flex'>
                            <div className={`${searchClearBtn ? 'col-10' : 'col-12'}`}>
                                <input
                                    placeholder={typeAheadSearchLabelTxt.LocationDefaultTxt}
                                    value={regionName}
                                    type="text"
                                    class={`search-input-field-responsive form-control p-0 ${searchSelected && regionName !== "" ? "font-weight-bolder": ""}`}
                                    data-testid="typeahead-input-button"
                                    id="search-input"
                                    autocomplete="off"
                                    onFocus={displayRecentSearch}
                                    onChange={getSearchResult}
                                    aria-label={typeAheadSearchLabelTxt.InputDefaultText}
                                />
                            </div>

                            <div className='col-2 d-flex align-self-center justify-content-end'>
                                {searchClearBtn && <button type='button' aria-label="clear location" className='clear-Btn' onClick={clearSearchKey}>{typeAheadSearchLabelTxt.ClearFieldText}</button>}
                            </div>

                            </div>

                        </div>
                        <div className='d-md-none col-12 mt-2'>
                            <label className="px-0 bold mb-0 font-weight-bolder">{typeAheadSearchLabelTxt.LocationLabelTxt}</label>
                            <div className='d-flex'>
                            <input
                                placeholder={typeAheadSearchLabelTxt.LocationDefaultTxt}
                                value={regionName}
                                type="text"
                                class={`search-input-field-responsive form-control p-0 w-100 ${searchSelected && regionName !== "" ? "font-weight-bolder": ""}`}
                                data-testid="typeahead-input-button"
                                id="mobile-input-search-holder"
                                autocomplete="off"
                                onClick={mobileSearchTraySlide}
                                readOnly="true"
                            />
                             {searchClearBtn && <button type='button' className='clear-Btn float-right flex-shrink-1' onClick={clearSearchKey}>{typeAheadSearchLabelTxt.ClearFieldText}</button>}
                            </div>
                            
                        </div>
                        <SearchHiddenForm searchObj={searchObj} searchKeyWord={searchKeyWord} />
                        <div className={`${!showRegion ? "d-lg-none input-options" : "input-options p-lg-2 px-lg-4 slide-options"}`}>
                            <div className="d-flex border-bottom d-lg-none py-3 px-2">
                                
                            <a className="points-x-small bold py-3 col-1 black-link-color" href="#!" onClick={backMainSearch}>
                            <img src={`${REACT_APP_IMAGEURL}/static/images/rebrand-ds/Arrow-left.png`} width="24px" height="24px" alt="arrow-img"/>
                            </a>
                                <input
                                    placeholder={typeAheadSearchLabelTxt.LocationDefaultTxt}
                                    value={regionName}
                                    type="text"
                                    className={`${searchSelected && regionName !== "" && "font-weight-bolder"} form-control col-9 py-0`}
                                    data-testid="typeahead-input-button"
                                    id="mobile-search-input"
                                    autocomplete="off"
                                    onChange={getSearchResult}
                                    onFocus={mobileDisplayRecentSearch}
                                    ref ={inputRef}
                                />
                                 {searchClearBtn && <button type='button' className='clear-Btn float-right col-2 mb-0 d-flex align-items-center justify-content-center' onClick={clearSelectedLocationMobile}>{typeAheadSearchLabelTxt.ClearFieldText}</button>}
                            </div>
                            <div className="text-uppercase py-2 d-none d-lg-block">{typeAheadSearchLabelTxt.RegionDefaultTxt}</div>
                                {displayErrorMsg && 
                                <div className='bg-warning p-2 rounded m-3 m-lg-0 mb-lg-2 d-flex'>
                                    <WarningIcon/>
                                    <span className='mx-2 font-weight-bold align-self-center'>{typeAheadSearchLabelTxt.SearchDropdownDetails.ErrorInfoText}</span>
                                </div>
                                    }
                            {searchResultData !== null &&
                                <>
                                    <GeocodeResortList searchedResultData={searchResultData} selectingSearchOptions={selectSearchOptions} />
                                    <RciDictResortList searchedResultData={searchResultData} selectingSearchOptions={selectSearchOptions} />
                                    <RciValuesResortList searchedResultData={searchResultData} selectingSearchOptions={selectSearchOptions} />
                                    <RciResortValueResortList searchedResultData={searchResultData} selectingSearchOptions={selectSearchOptions} />
                                </>
                            }
                            {recentSearchData !== null && searchResultData === null && recentSearchData.length > 0 &&
                                <>
                                    <span className="px-3 py-2 font-weight-bolder">{typeAheadSearchLabelTxt.SearchDropdownDetails.RecentSearchesText}</span>
                                    {recentSearchData.map((regionData, indexKey) => {
                                        return (
                                            <li className="p-2 region" tabindex="0" aria-label={regionData.label} data-testid={`region-input-options-${indexKey}`} key={indexKey} id={regionData.regionId} onClick={(e) => selectRecentSearchOptions(e, regionData)} onKeyDown={(e) => selectRecentSearchOptions(e, regionData)}>
                                                <span className="media">
                                                <span className='d-flex align-self-start'><SearchHistoryIcon className="svg-fill-black mr-3" /></span>
                                                <span className="media-body">
                                                <span className="font-weight-bold d-block d-md-inline">{ReactHtmlParser(regionData.label)}</span> <span>{ReactHtmlParser(regionData.displayAddLabel)}</span>
                                                </span>
                                                </span>
                                            </li>
                                        )
                                    })}

                                </>

                            }

                        </div>
                    </div>
                    <div className={`col-lg-3 search-row-border p-3 p-lg-0 ${showRegion ? "d-lg-none" : ""}`}>
                      
                        <div className={`calender-btn ${displayCheckinCalender ? "active" : ""}`} id="earliest-checkinDate">
                            <div  className="d-flex button-wrapper-container" >
                                <div className="flex-grow-1" aria-describedby="select earliest checkin date" data-testid="earliest-checkin-date-button" onClick={e => showCheckInCalender(e)}>
                                <span className={`d-block heading font-weight-bolder ${displayCheckinCalender ? "active" : ""}`}
                                    onMouseOver={(e) => tooltipdisplay(e)}
                                    onMouseOut={(e) => tooltipdisplay(e)}
                                >{typeAheadSearchLabelTxt.EarliestCheckInLabel}</span>

                                <span className="tooltip-text">{typeAheadSearchLabelTxt.EarliestCheckInLabel}{/* <span className="tooltip-arrow-down"></span> */}</span>
                                <span className="d-inline-flex pt-2 text-muted">{displayCheckInDate ? displayCheckInDate : typeAheadSearchLabelTxt.DatePlaceHolder}</span>

                                </div>
                                {checkInClearBtn && <button type='button' aria-label="clear earliest check in date" className='clear-Btn float-right pt-4 px-3' onClick={ClearEarliestCkeckInDate}>{typeAheadSearchLabelTxt.ClearFieldText}</button>}
                               
                            </div>
                          
                        </div>
                        {
                            displayCheckinCalender &&
                            <div className={displayCheckinCalender ? "col-lg-12 calender-contianer slide-in border-primary" : "d-lg-none calender-contianer"} data-testid="earliest-checkin-date-calender">
                            <div className="col-12 border-bottom d-lg-none pb-2 checkIn-calender-heading-position">
                                <a className="points-x-small bold py-3 d-block black-link-color" href="#!" onClick={backMainSearch}>
                                    <img src={`${REACT_APP_IMAGEURL}/static/images/rebrand-ds/Arrow-left.png`} width="24px" height="24px" />
                                    {typeAheadSearchLabelTxt.EarliestCheckInLabel}
                                </a>
                                <span>{displayCheckInDate ? displayCheckInDate : typeAheadSearchLabelTxt.DatePlaceHolder}</span>
                                {mobileCalenderCheckInClearBtn && <button type='button' aria-label="clear earliest check in date" className='clear-Btn float-right px-3' onClick={ClearMobileEarliestCkeckInDate}>{typeAheadSearchLabelTxt.ClearFieldText}</button>}
                            </div>
                            {CheckInDateCal}
                        </div>
                        }
                      
                    </div>

                    <div className={`col-lg-3 search-row-border p-3 p-lg-0 d-flex ${showSubRegion && "d-sm-none d-lg-block"}`}>

                        <div className={`calender-btn flex-grow-1 ${displayCheckOutCalender ? "active" : ""}`}
                            onClick={showCheckOutCalender}
                            data-testid="latest-checkin-date-button"
                            aria-describedby="select latest checkin date"
                            >
                            <span className="button-wrapper-container border-0">
                                <span className={`d-block heading date-heading font-weight-bolder ${displayCheckOutCalender ? "active" : ""}`}
                                >{typeAheadSearchLabelTxt.LatestCheckInLabel}</span>
                                <span className="tooltip-text">{typeAheadSearchLabelTxt.LatestCheckInLabel}</span>
                                <span className="d-inline-flex pt-2 text-muted">{displayCheckOutDate ? displayCheckOutDate : typeAheadSearchLabelTxt.DatePlaceHolder}</span>
                               
                            </span>
                        </div>
                        {latestCheckInClearBtn && <button type='button' aria-label="clear latest check in date" className='clear-Btn float-right pt-4 px-3' onClick={ClearLatestCkeckInDate}>{typeAheadSearchLabelTxt.ClearFieldText}</button>}
                        <div className={displayCheckOutCalender ? "col-lg-12 calender-contianer check-out slide-in" : "d-lg-none check-out calender-contianer"} data-testid="earliest-checkin-date-calender">
                            <div className="col-12 border-bottom pb-2 d-lg-none">
                                <a className="points-x-small bold py-3 d-block black-link-color" href="#!" onClick={backMainSearch}>
                                    <img src={`${REACT_APP_IMAGEURL}/static/images/rebrand-ds/Arrow-left.png`} width="24px" height="24px" />
                                    {typeAheadSearchLabelTxt.LatestCheckInLabel}
                                </a>
                                <span>{displayCheckOutDate ? displayCheckOutDate:typeAheadSearchLabelTxt.DatePlaceHolder}</span>
                                {mobileCalenderCheckOutClearBtn && <button type='button' aria-label="clear latest check in date" className='clear-Btn float-right px-3' onClick={ClearMobileLatestCkeckInDate}>{typeAheadSearchLabelTxt.ClearFieldText}</button>}
                            </div>
                            {displayCheckOutCalender && CheckOutDateCal}
                            
                        </div>
                        
                    </div>
                    {
                        availibilityContainer &&
                        <div role="alert" class="row availibility-warning">
                            <div className='col-md-1 align-self-center'><NotificatinWarningIcon/></div>
                            <div className='col-md-11 p-0 d-md-flex d-block'>
                                <div  className="font-weight-normal p-2">{ReactHtmlParser(availibilityCalenderMsg)} </div>
                                <div className='flex-shrink-0 align-self-center text-black'>
                                    <a href="/weeks-account/extendDeposit/extension-Details?promo=MRCH10002704" className="bg-priority rounded p-3 shadow-2 font-weight-bolder">
                                    {ReactHtmlParser(availibilityCalenderBtn)}
                                    </a>
                                     </div>
                               
                                
                                </div>
                           
                        </div>

                    }
                    <div className={$deviceWidth < 1024 ? "col-lg-3 type-search-button-holder" : "col-lg-2 justify-content-lg-end d-flex p-2"}>
                        <button type="button"
                            onClick={submitSearch}
                            aria-label="search for location"
                            data-testid="type-ahead-search-button"
                            className="w-100 btn btn-primary btn-icon align-self-center">
                            <SearchIcon />{typeAheadSearchLabelTxt.SearchButton.DisplayText}
                        </button>
                    </div>


                </div>
            </div>
            <div onClick={searchTrayClose}>
                {displaySearchTrayFlag && <Overlay />}
            </div>
        </>
    )
}

export default SearchTray;

//@ function for rendering Geocode resort list  in the input options
const GeocodeResortList = ({ searchedResultData, selectingSearchOptions }) => {
    return searchedResultData.geocodeValues.map((resultData, resultIndex) => {
        return (
            <li className="p-2 region" tabindex="0" aria-label={resultData.label} data-testid={`region-input-options-${resultIndex}`} id={resultData.regionId} onKeyDown={(e) => selectingSearchOptions(e, resultData)} onClick={(e) => selectingSearchOptions(e, resultData)} key={resultData.regionId}>
                <span className='media'>
                <span className='d-flex '><LocationIcon className="svg-fill-black mr-3" /></span>
                <span className='media-body'>
                <span className="font-weight-bold d-block d-md-inline">{ReactHtmlParser(resultData.label)} </span> 
                <span>{ReactHtmlParser(resultData.displayAddLabel)}</span>
                </span>
               
                </span>
                
            </li>
        )

    })
}
//@ function for rendering Rci Dictonary resort list  in the input options
const RciDictResortList = ({ searchedResultData, selectingSearchOptions }) => {
    return searchedResultData.rciDictValues.map((resultData, resultIndex) => {
        return (
            <li className="p-2 region" tabindex="0" aria-label={resultData.label} data-testid={`region-input-options-${resultIndex}`} id={resultData.regionId} onKeyDown={(e) => selectingSearchOptions(e, resultData)} onClick={(e) => selectingSearchOptions(e, resultData)} key={resultData.regionId}>
                 <span className='media'>
                    <span className='d-flex'><LocationIcon className="svg-fill-black mr-3" /></span>
                <span className='media-body'>
                    <span className="font-weight-bold d-block d-md-inline">{ReactHtmlParser(resultData.label)} </span> 
                    <span>{ReactHtmlParser(resultData.displayAddLabel)}</span>
                </span>
                </span>
            </li>
        )

    })
}
//@ function for rendering Rci values resort list  in the input options
const RciValuesResortList = ({ searchedResultData, selectingSearchOptions }) => {
    return searchedResultData.rciValues.map((resultData, resultIndex) => {
        return (
            <li className="p-2 region" tabindex="0" aria-label={resultData.label} data-testid={`region-input-options-${resultIndex}`} id={resultData.regionId} onKeyDown={(e) => selectingSearchOptions(e, resultData)} onClick={(e) => selectingSearchOptions(e, resultData)} key={resultData.regionId}>
                <span className='media'>
                    <span><LocationIcon className="svg-fill-black mr-3" /></span>
                <span className='media-body'>
                    <span className="font-weight-bold d-block d-md-inline">{ReactHtmlParser(resultData.label)} </span> 
                    <span>{ReactHtmlParser(resultData.displayAddLabel)}</span>
                </span>
                </span>
            </li>
        )

    })
}
//@ function for rendering Rci resort values list  in the input options
const RciResortValueResortList = ({ searchedResultData, selectingSearchOptions }) => {
    return searchedResultData.resortValues.map((resultData, resultIndex) => {
        return (
            <li className="p-2 region" tabindex="0" aria-label={resultData.label} data-testid={`region-input-options-${resultIndex}`} id={resultData.regionId} onKeyDown={(e) => selectingSearchOptions(e, resultData)} onClick={(e) => selectingSearchOptions(e, resultData)} key={resultData.regionId}>
                <span className='media'>
                <span><LocationIcon className="svg-fill-black mr-3" /></span>
                <span className='media-body'>
                <span className="font-weight-bold d-block d-md-inline">{ReactHtmlParser(resultData.label)} </span> 
                <span>{ReactHtmlParser(resultData.displayAddLabel)}</span>
                </span>
                </span>
            </li>
        )

    })

}

//@ Search form to submit details for search result
const SearchHiddenForm = ({ searchObj, searchKeyWord }) => {

    return (
        <form
            autocomplete="off"
            id="quick-search-form"
            class="hidden"
            action="/"
            method="post"></form>
    )


}